// extracted by mini-css-extract-plugin
export default {"container":"Timer_container__yzcq7"};